export enum DCViewEnum {
  LIST = 'list',
  TABLE = 'table',
}
